"use client";

import { useEffect } from "react";

const FILE_EXT =
  /\.(zip|rar|7z|tar|gz|pdf|docx?|xlsx?|pptx?|txt|csv|md|mp3|wav|mp4|mov|apk|dmg|exe|iso)(\?.*)?$/i;

export default function ContentEnhancer() {
  useEffect(() => {
    const root = document.querySelector<HTMLElement>(".wmde-markdown");
    if (!root) return;

    root.querySelectorAll<HTMLAnchorElement>("a[href]").forEach((a) => {
      const href = a.getAttribute("href") ?? "";
      if (!href || href.startsWith("#")) return;

      if (FILE_EXT.test(href)) {
        a.classList.add("md-file-link");
        a.setAttribute("download", "");
        return;
      }

      const isExternal = /^https?:\/\//i.test(href) && !href.includes(location.host);
      if (isExternal) {
        a.classList.add("md-ext-link");
        a.target = "_blank";
        a.rel = "noopener noreferrer";
      }
    });

    root
      .querySelectorAll<HTMLElement>("pre > code[class*='language-']")
      .forEach((code) => {
        const match = /language-([\w-]+)/.exec(code.className);
        const lang = match?.[1];
        const pre = code.parentElement;
        if (pre && lang && lang !== "text" && lang !== "mermaid") {
          pre.setAttribute("data-language", lang);
        }
      });

  }, []);

  return null;
}
